import { jsx as t, jsxs as z } from "react/jsx-runtime";
import { Avatar as F, alpha as V, Stack as w, Chip as D } from "@mui/material";
import { DiaryItemPropertyTypeEnum as m, PaymentStatusEnum as M, DiaryItemAttendanceStatus as N, DiaryEntryType as I } from "../../../helpers/daymaptypes.js";
import { V as b, X as $, E as P, Y as x, Z as L, e as A, C as j, D as E, b as k, k as R, l as W } from "../../../pointsGraph-DTJju-rA.js";
import { prettyDate as T } from "../../../helpers/dates.js";
import { M as B } from "../../../Label-DyVniv3J.js";
const H = ({
  title: u,
  description: y,
  date: p,
  chips: r,
  eventType: h,
  colour: e,
  onClick: a,
  properties: s,
  record: n,
  studentId: l,
  calendarName: c,
  location: S,
  period: g
}) => {
  let { icon: f, color: v } = b({ eventType: h, calendarName: c }, { sx: { width: 20, height: 20 } });
  e = e == null || e == "" ? v : e.startsWith("#") ? e : `#${e}`;
  let C = /* @__PURE__ */ t(F, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: V(e, 0.15), color: e }, children: f });
  const o = [r];
  l && o.push(/* @__PURE__ */ t(R, { size: "small", studentId: l }, "student")), s == null || s.forEach((i) => {
    if (i.Type === m.AvatarContactID) {
      Number.isNaN(i.Value) || ({ icon: f } = b({ eventType: h, calendarName: c }, { sx: { width: 15, height: 15 } }), C = /* @__PURE__ */ t($, { contactId: Number(i.Value), color: v, icon: f }));
      return;
    }
    o.push(/* @__PURE__ */ t(P, { Type: i.Type, Value: i.Value }, `${i.Type} ${i.Value}`));
  }), S && !(s != null && s.some((i) => i.Type === m.Location)) && o.push(/* @__PURE__ */ t(P, { Type: m.Location, Value: S }, "location")), n && (o.push(/* @__PURE__ */ t(x, { size: "small", statusCaption: n.StatusCaption, statusType: n.StatusType, statusFlags: n.StatusFlags }, "record status")), n.MobilePayment && n.MobilePayment.PayStatus !== M.None && o.push(/* @__PURE__ */ t(L, { size: "small", payment: n.MobilePayment }, "payment")));
  let d;
  return g && (d = /* @__PURE__ */ z(w, { alignItems: "flex-end", sx: { height: "5px" }, children: [
    p && /* @__PURE__ */ t("span", { children: T(p) }, 2),
    /* @__PURE__ */ t("span", { children: g }, 3)
  ] }, 1)), /* @__PURE__ */ t(A, { itemType: "event", title: u, description: y, date: d ? void 0 : p, chips: o, avatar: C, onClick: a, category: d });
}, J = ({ hideStudentChip: u, onClick: y, StudentID: p, AttendanceStatus: r, AttendanceReason: h, chips: e, ...a }) => {
  let s = [];
  (a.Start <= /* @__PURE__ */ new Date() || r !== N.RollNotMarked) && s.push(/* @__PURE__ */ t(W, { size: "small", attendanceStatus: r, absentDescription: h }, "attendance")), a.Staff && a.Staff.length > 0 && a.Staff.forEach((l, c) => {
    l.ID && s.push(/* @__PURE__ */ t(j, { size: "small", staffId: l.ID, label: l.DisplaynameSurname }, `staff-${c}`));
  }), a.Type === I.Task && (a.Start && s.push(/* @__PURE__ */ t(D, { size: "small", label: `Starts ${T(a.Start)}`, icon: /* @__PURE__ */ t(E, { iconType: k.Start }) }, "start")), a.Finish && a.Finish > a.Start && s.push(/* @__PURE__ */ t(D, { size: "small", label: `Due ${T(a.Finish)}`, icon: /* @__PURE__ */ t(E, { iconType: k.Warning }) }, "due"))), s = [...s, ...e ?? []];
  const n = a.Text.replace(/<br\s*\/?>/gi, "");
  return /* @__PURE__ */ t(
    H,
    {
      title: a.Title,
      description: /* @__PURE__ */ t(
        B,
        {
          components: {
            p: ({ children: l }) => /* @__PURE__ */ t("p", { style: { margin: 0 }, children: l })
          },
          skipHtml: !0,
          allowedElements: ["p"],
          children: n
        }
      ),
      date: a.Type == I.Task ? a.Finish : a.Start,
      eventType: a.Type,
      colour: a.Colour,
      properties: a.Properties,
      onClick: y ? () => y({ StudentID: p, AttendanceStatus: r, AttendanceReason: h, ...a }) : void 0,
      record: a.Record,
      studentId: u ? void 0 : p,
      calendarName: a.Calendar,
      location: a.Location,
      chips: s,
      period: a.PeriodFrom
    }
  );
};
export {
  J as DiaryItem,
  H as EventItem
};
//# sourceMappingURL=events.js.map
